import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { Subscription } from 'rxjs';
import { LottosService } from '../../services/lottos/lottos.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-lotto-box',
  templateUrl: './lotto-box.component' + AuthService.multisite.view + '.html',
  styleUrls: ['./lotto-box.component.scss']
})
export class LottoBoxComponent implements OnInit {
  @Input() lottoId: number = environment.lottery.lot_id;
  @Input() system: string;
  @Input() product: string = 'lottos'; // lottos / syndicates / raffles
  public lotto: any = environment.lottery;
  public lottoName: any;
  public country: string;
  public subscription: Subscription;

  constructor(protected lottos: LottosService) {}

  ngOnInit(): void {
    this.setLottoId();
  }

  setLottoId(): void {
    this.lottos.getLottoss(this.lottoId, this.system, this.product);
    this.setLotto();
  }

  setLotto(): void {
    this.subscription = this.lottos.lottoObservable$.subscribe((lottoObj) => {
      this.lottoName = lottoObj['name'];
      this.country = lottoObj['country'];
    });
  }

  ngDestroy(): void {
    this.subscription.unsubscribe();
  }
}
